export { API, errText, when } from "@/components/bulk/common";
import { API } from "@/components/bulk/common";

export const igImg = (file) => `${API}/public/ig/${file}`;
export const KIND = { feed: "Post", story: "Story" };
export const IG_STATUS = {
  scheduled: ["Zamanlandı", "scheduled"], publishing: ["Paylaşılıyor", "sending"], done: ["Paylaşıldı", "done"],
  partial: ["Kısmen paylaşıldı", "paused"], failed: ["Paylaşılamadı", "cancelled"], cancelled: ["İptal edildi", "draft"],
};
export const ACCOUNT = { BUSINESS: "İşletme hesabı", MEDIA_CREATOR: "İçerik üreticisi hesabı" };
